import React, { useEffect, useState } from "react";
import { Button, Form, Message } from "semantic-ui-react";

export default function InstructorCareerEditor({ instructorId }) {
  const [items, setItems] = useState(["", "", ""]);
  const [csrf, setCsrf] = useState("");
  const [ready, setReady] = useState(false);
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState(null);
  const endpoint = `${process.env.REACT_APP_API_URL}/api/instructors/${instructorId}/career/`;

  useEffect(() => {
    let active = true;
    setReady(false);
    setMessage(null);
    fetch(endpoint, { credentials: "include" })
      .then(async (response) => {
        const data = await response.json();
        if (!response.ok) throw new Error(data.error || "経歴を取得できませんでした。");
        if (active) {
          setItems(Array.from({ length: 3 }, (_, index) => data.highlights?.[index] || ""));
          setCsrf(data.csrf_token);
          setReady(true);
        }
      })
      .catch((error) => active && setMessage({ error: true, text: error.message }));
    return () => { active = false; };
  }, [endpoint]);

  const save = async () => {
    setBusy(true);
    setMessage(null);
    try {
      const response = await fetch(endpoint, {
        method: "POST", credentials: "include",
        headers: { "Content-Type": "application/json", "X-CSRFToken": csrf },
        body: JSON.stringify({ highlights: items }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || "経歴を保存できませんでした。");
      setItems(Array.from({ length: 3 }, (_, index) => data.highlights[index] || ""));
      setCsrf(data.csrf_token);
      setMessage({ error: false, text: "掲載用の経歴を保存しました。" });
    } catch (error) {
      setMessage({ error: true, text: error.message });
    } finally { setBusy(false); }
  };

  return (
    <div>
      <h4>スタジオページの吹き出し経歴</h4>
      <p>最大3件・各60文字。上から順に表示します。空欄は表示されません。確認済みの経歴を入力してください。</p>
      <Form>
        {items.map((text, index) => (
          <Form.Field key={index}>
            <label htmlFor={`career-${index}`}>経歴 {index + 1}（{text.length}/60）</label>
            <input id={`career-${index}`} value={text} maxLength={60} disabled={!ready || busy}
              onChange={(event) => {
                const value = event.target.value;
                setItems((previous) => previous.map((item, i) => i === index ? value : item));
                setMessage(null);
              }} />
          </Form.Field>
        ))}
        <Button type="button" primary disabled={!ready || busy} loading={busy} onClick={save}>吹き出し経歴を保存</Button>
      </Form>
      {message && <Message role={message.error ? "alert" : "status"} negative={message.error} positive={!message.error}>{message.text}</Message>}
    </div>
  );
}
